import { TranslateModule, TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { catchError, tap } from 'rxjs/operators';
import {
  AlertButton,
  AlertController,
  Gesture,
  IonicModule,
  ModalController,
  ToastController,
  ViewDidEnter,
} from '@ionic/angular';
import { DatePipe, NgClass, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CrListItemComponent } from '../cr-list-item/cr-list-item.component';
import { CrListVueJourComponent } from '../cr-list-vue-jour/cr-list-vue-jour.component';
import { CrListVueSemaineComponent } from '../cr-list-vue-semaine/cr-list-vue-semaine.component';
import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, signal } from '@angular/core';
import { CrActiviteInterne } from '../../../shared/models/activite-interne/activite-interne.model';
import { LoggerWrapper } from '../../../shared/providers/logger/logger-wrapper.service';
import { NetworkProvider } from '../../../shared/providers/network/network';
import { StorageProvider } from '../../../shared/providers/storage/storage';
import { ActivitesProvider } from '../../../shared/providers/activites/activites';
import { UtilsServices } from '../../../shared/components/utils-services';
import { Events } from '../../../shared/providers/events/events.provider';
import { LoggerFactory } from '../../../shared/providers/logger/logger-factory.service';
import { MenuService } from '../../../shared/providers/menu.service';
import { ActiviteInterneService } from '../../../shared/providers/activite-interne/activite-interne.service';
import { OfflineSyncProvider } from '../../../shared/providers/offline-sync/offline-sync';
import { EMPTY, forkJoin, lastValueFrom } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { minusDays, minusWeek, plusDays, plusWeek, sameDay } from '../../common/utils/date-util';
import { TypeDataRequest } from '../../../shared/providers/requests/requests';
import { Keyboard } from '@capacitor/keyboard';
import { ConnectionStatus, Network } from '@capacitor/network';
import { ActivatedRoute, Router } from '@angular/router';
import { GestureService } from '../../../shared/providers/gesture/gesture.service';
import { TimeCounterTileComponent } from '../../../shared/design-system/time-counter-tile/time-counter-tile.component';
import { GaugeBarData } from '../../../shared/design-system/gauge-bar/gauge-bar.component';
import { ActivitesSaisies } from '../../../shared/models/heures-saisies.model';
import { HeuresSaisiesService } from '../../../shared/providers/heures-saisies/heures-saisies-service';
import { CalendarModal } from './calendar/calendar.modal';
import { DraftCrService } from '../../../shared/providers/draft/draft-cr.service';
import { ChronoInput } from '../../../shared/models/chrono.model';
import { CrBrouillonListItemComponent } from '../cr-brouillon-list-item/cr-brouillon-list-item.component';
import { CrActiviteInterneItemComponent } from '../cr-activite-interne-item/cr-activite-interne-item.component';
import { CrView } from '../../../shared/models/v2/cr.model';
import { PostCrRequest, PostCrResponse } from '../../../shared/models/v2/post-cr.model';
import { UnplannedOt } from '../../../shared/models/v2/ot.model';
import { TodayPastilleComponent } from '../../../shared/design-system/today-pastille/today-pastille.component';
import { AccordionComponent } from '../../common/components/accordion/accordion.component';
import { CrResponse } from '../../../api/models/cr-response';

export enum segmentsViewEnum {
  DAY = 'jour',
  WEEK = 'semaine',
}

const SYNTHESE_DETAILLEE_DES_HEURES: boolean = true;

// CrView: Brouillon OT
// ChronoInput: Brouillon OT Non planifié
// CrResponse: OT Envoyés
// PostCrRequest: OT En cours d'envoi
// CrActiviteInterne: Activites interne

/**
 * Page de la liste de CR  (API + brouillon local)
 *
 * Cette page permet à l'utilisateur de voir ces CR
 *
 * @export
 * @class CrListPage
 */
@Component({
  selector: 'page-cr-list',
  templateUrl: 'cr-list.page.html',
  standalone: true,
  styleUrls: ['./cr-list.page.scss'],
  imports: [
    IonicModule,
    TranslateModule,
    DatePipe,
    FormsModule,
    NgIf,
    CrListItemComponent,
    CrListVueJourComponent,
    CrListVueSemaineComponent,
    TimeCounterTileComponent,
    CrBrouillonListItemComponent,
    CrActiviteInterneItemComponent,
    TodayPastilleComponent,
    NgClass,
    AccordionComponent,
  ],
})
export class CrListPage implements OnInit, AfterViewInit, OnDestroy, ViewDidEnter {
  /**
   * Définis les données à afficher selon l'onglet selectionné
   */
  segments: segmentsViewEnum;

  /**
   * Date actuelle de la tournée
   *
   * @type {string}
   */
  selectedDate: Date = null;
  /**
   * Liste des CR
   */
  cr_list: (CrView | ChronoInput | CrActiviteInterne)[] = [];
  /**
   * Liste des CR brouillons
   */
  cr_list_brouillon: (CrView | ChronoInput | UnplannedOt)[] = [];
  /**
   * Liste des CR user
   */
  cr_list_user: (PostCrResponse | CrActiviteInterne)[] = [];
  /**
   * Liste des CR filtrés
   */
  cr_list_user_filtered: (CrView | PostCrResponse | ChronoInput | CrActiviteInterne)[] = [];

  cr_en_cours_denvoi: PostCrRequest[] = [];

  /**
   * Liste des CR en cours d'envoi filtrée en fonction du jour ou de la semaine (utilisée pour le mode offline)
   */
  cr_en_cours_denvoi_filtered: PostCrRequest[] = [];

  /**
   * Liste des CR d'activités interne
   */
  crsActiviteInterne: CrActiviteInterne[];
  /**
   * Boolean pour la gestion du chargement
   */
  loading_brouillon = signal(false);
  loading = signal(false);
  /**
   * Boolean pour afficher ou non la toolbar de recherche
   */
  showSearchbar = signal(false);
  /**
   * Champs de recherche
   */
  search: string = '';

  /**
   * Tableau des CR brouillons a supprimer
   */
  draftCrToDeleteList: (ChronoInput | CrView | UnplannedOt)[] = [];

  useCacheDate: any = null;

  /**
   * Logger
   */
  private logger: LoggerWrapper;

  /**
   * Est connecté au réseau mobile
   */
  public isConnected: boolean = true;

  disableNavigateToNextTime: boolean = false;
  disableNavigateToPreviousTime: boolean = false;

  /**
   * Booléen vérifiant si le mode suppression des brouillons est actif
   */
  isDraftCrDeletionModeActive = false;

  /**
   * Le numéro de la semaine
   */
  week: number;

  startOfWeek: string;
  endOfWeek: string;

  minutesDone: number = 0;
  maxMinutesInDay: number = 480;
  maxMinutesInWeek: number = 2280;

  gaugeData: GaugeBarData[] = [];

  showSyntheseDesHeures: boolean;
  gesture: Gesture;
  showSyntheseDesHeuresDetails: boolean = false;
  defaultDate: Date = new Date();

  todayInSelectedDates = signal<boolean>(true);

  /**
   * Constructeur
   *
   * Crée une instance de CrListPage
   *
   * @param networkProvider
   * @param {StorageProvider} storageProvider
   * @param alertCtrl
   * @param {ActivitesProvider} activitesProvider
   * @param {TranslateService} translate
   * @param utilsServices
   * @param events
   * @param loggerFactory
   * @param menuService
   * @param serviceActiviteInterne
   * @param {ToastController} toastController
   * @param offlineSyncProvider
   * @param router
   * @param route
   * @param gestureService
   * @param elementRef
   * @param heuresSaisiesService
   * @param modalController
   * @param zone
   * @param datePipe
   * @param draftCrService
   */
  constructor(
    private networkProvider: NetworkProvider,
    private storageProvider: StorageProvider,
    private alertCtrl: AlertController,
    private activitesProvider: ActivitesProvider,
    private translate: TranslateService,
    private utilsServices: UtilsServices,
    private events: Events,
    private loggerFactory: LoggerFactory,
    private menuService: MenuService,
    private serviceActiviteInterne: ActiviteInterneService,
    private toastController: ToastController,
    private offlineSyncProvider: OfflineSyncProvider,
    private router: Router,
    private route: ActivatedRoute,
    private gestureService: GestureService,
    private elementRef: ElementRef,
    private heuresSaisiesService: HeuresSaisiesService,
    private modalController: ModalController,
    private zone: NgZone,
    private datePipe: DatePipe,
    private draftCrService: DraftCrService
  ) {
    this.logger = this.loggerFactory.getInstance(this);
    this.events.subscribe('cr_list_update', () => {
      this.useCacheDate = null;
    });

    this.showSyntheseDesHeures = SYNTHESE_DETAILLEE_DES_HEURES;
  }

  ngOnInit() {
    this.segments = segmentsViewEnum.DAY;
    if (this.selectedDate == null) {
      this.selectedDate = new Date();
    }
    this.startOfWeek = moment().startOf('isoWeek').toISOString();
    this.endOfWeek = moment().endOf('isoWeek').toISOString();
    //
    const segment = this.route.snapshot.queryParams['segments'];
    if (segment) {
      this.segments = segment;
    }
    this.segmentAction();
  }

  ngAfterViewInit() {
    this.createSwipeGesture();
  }

  ngOnDestroy(): void {
    this.gesture.destroy();
  }

  createSwipeGesture() {
    this.gesture = this.gestureService.createHorizontalSwipeGesture(
      this.elementRef.nativeElement.closest('ion-content'),
      () => {
        this.zone.run(() => this.previous());
      },
      () => {
        this.zone.run(() => this.next());
      }
    );
    this.gesture.enable();
  }

  calculerDisableNavigation() {
    let minDate = moment().subtract(5, 'week').toDate();
    if (this.segments === segmentsViewEnum.DAY) {
      this.disableNavigateToPreviousTime = sameDay(this.selectedDate, minDate);
      this.disableNavigateToNextTime = sameDay(this.selectedDate, new Date());
    } else if (this.segments === segmentsViewEnum.WEEK) {
      this.disableNavigateToPreviousTime = moment(minDate).isBetween(this.startOfWeek, this.endOfWeek);
      this.disableNavigateToNextTime = moment().isBetween(this.startOfWeek, this.endOfWeek);
    }
  }

  async checkNetwork() {
    this.isConnected = await this.networkProvider.isReallyConnected();
    Network.addListener('networkStatusChange', (status: ConnectionStatus) => {
      this.isConnected = status.connected;
    });
  }

  /**
   * Retourne le nombre de notification à afficher sur le menu burger
   */
  get burgerBadge(): number {
    return this.menuService.getNotifications();
  }

  async doRefresh(refresher) {
    await this.refresh();
    refresher.target.complete();
  }

  /**
   * Lorsque la page est affichée
   */
  async ionViewDidEnter() {
    await this.checkNetwork();
    if (this.useCacheDate == null || this.useCacheDate != this.utilsServices.getTodayKey()) {
      await this.refresh();
    }
  }

  /**
   * Chargement des données
   */
  async refresh(): Promise<any> {
    this.loading.set(true);
    this.loading_brouillon.set(true);
    this.cr_list_brouillon = [];
    this.cr_en_cours_denvoi = await this.getCrsEnCoursDenvoi();

    return await lastValueFrom(
      forkJoin([fromPromise(this.serviceActiviteInterne.getCr()), fromPromise(this.getCrOtPromise())]).pipe(
        tap(([crActivite, crOt]) => {
          this.crsActiviteInterne = crActivite;
          this.cr_list_user = [...this.orderByDate(crOt || []), ...this.crsActiviteInterne];
          this.createFinalList();
          this.useCacheDate = this.utilsServices.getTodayKey();
        }),
        catchError(() => {
          this.loading_brouillon.set(false);
          this.loading.set(false);
          return EMPTY;
        })
      )
    );
  }

  async getCrOtPromise(): Promise<PostCrResponse[]> {
    try {
      const data: CrView[] = await this.draftCrService.getAllCrDrafts();
      if (data && data.length > 0) {
        this.cr_list_brouillon = data.filter(
          (cr) => !['clos_intervenant', 'clos_valide', 'annule'].includes(cr.ot.statut_ot)
        );
      }
      const data_1: UnplannedOt[] = await this.storageProvider.get('DraftOtUnplanned');
      if (data_1 && data_1.length > 0) {
        this.cr_list_brouillon = this.cr_list_brouillon.concat(data_1);
        this.cr_list_brouillon = this.orderByDate(this.cr_list_brouillon).reverse();
      }
      this.loading_brouillon.set(false);
      let crViews = await this.activitesProvider.getListCrByIntervenant();

      return crViews.map((cr) => {
        let assign = Object.assign({} as PostCrResponse, cr);
        assign.type = 'cr-response';
        return assign;
      });
    } catch (err) {
      this.logger.warn('refresh error', err);
      this.loading_brouillon.set(false);
      this.loading.set(false);
      return [];
    }
  }

  async createFinalList() {
    await this.refreshCrsActiviteInterne();

    let list: (CrResponse | CrView | ChronoInput | CrActiviteInterne | UnplannedOt)[] = [];
    if (this.cr_list_brouillon.length > 0) {
      list = list.concat(this.cr_list_brouillon);
    }
    if (this.cr_list_user.length > 0) {
      list = list.concat(this.cr_list_user);
    }
    if (this.crsActiviteInterne.length > 0) {
      list = list.concat(this.crsActiviteInterne);
    }
    this.cr_list = this.orderByDate(list);

    this.loading.set(false);
    this.filterOtsAndActiviteInternesByDateAndCurrentSegment();
  }

  /**
   * Méthode appellé lorsque l'utilisateur clique sur le bouton de Recherche
   * Affiche / Cache la toolbar
   */
  toogleToolbar() {
    this.showSearchbar.set(!this.showSearchbar());
    this.search = '';
    this.cr_list_user_filtered = this.cr_list_user;
    if (!this.showSearchbar()) this.filterOtsAndActiviteInternesByDateAndCurrentSegment();
  }

  orderByDate(data: any[]): any[] {
    data.sort((a, b) => {
      let date_a = !a.ot && a.cr ? a.cr.date_modification_intervenant : a.date_creation;
      let date_b = !b.ot && b.cr ? b.cr.date_modification_intervenant : b.date_creation;
      if (new Date(date_a).getTime() < new Date(date_b).getTime()) {
        return 1;
      }
      if (new Date(date_a).getTime() > new Date(date_b).getTime()) {
        return -1;
      }
      if (a.ot?.numero_ot && b.ot?.numero_ot) {
        let numeroA: string = a.ot.numero_ot;
        let numeroB: string = b.ot.numero_ot;
        return numeroA.localeCompare(numeroB);
      }
      return 0;
    });
    return data;
  }

  filterOtsAndActiviteInternesByDateAndCurrentSegment() {
    if (this.segments === segmentsViewEnum.DAY) {
      this.filterOtsAndActiviteInternesByDateAndCurrentSegmentVueJour();
      this.refreshWeekNumberFromDateAndTodayPastille(this.selectedDate);
    } else if (this.segments === segmentsViewEnum.WEEK) {
      this.filterOtsAndActiviteInternesByDateAndCurrentSegmentVueSemaine();
      this.refreshWeekNumberFromDateAndTodayPastille(this.startOfWeek);
    }
  }

  /**
   * Méthode appelée pour que l'on affiche uniquement les CR du jour sélectionné
   */
  filterOtsAndActiviteInternesByDateAndCurrentSegmentVueJour() {
    console.log('cr_list_user', this.cr_list_user);
    this.cr_list_user_filtered = this.cr_list_user.filter((v) => {
      if (v.type === 'cr-response') {
        if (v.ot && v.date_creation && v.intervention_date_fin) {
          if (
            moment(v.intervention_date_fin).startOf('day').calendar() ==
            moment(this.selectedDate).startOf('day').calendar()
          ) {
            return true;
          }
        }
      }
      if (v.type === 'cr-activite-interne') {
        const crActiviteInterne = v as CrActiviteInterne;
        if (
          crActiviteInterne.cr_activite_interne_date_fin &&
          moment(crActiviteInterne.cr_activite_interne_date_fin)
            .startOf('day')
            .isSame(moment(this.selectedDate).startOf('day'))
        ) {
          return true;
        }
      }
      return false;
    });
    this.cr_en_cours_denvoi_filtered = this.cr_en_cours_denvoi.filter((cr) => {
      if (cr.ot && cr.date_creation && cr.intervention_date_fin) {
        if (
          moment(cr.intervention_date_fin).startOf('day').calendar() ==
          moment(this.selectedDate).startOf('day').calendar()
        ) {
          return true;
        }
      }
      return false;
    });
    let startDay = moment(this.selectedDate).startOf('day').toISOString();
    let endDay = moment(this.selectedDate).endOf('day').toISOString();
    this.calculDonnesHeuresSaisies(startDay, endDay);
    console.log('cr_list_user_filtered', this.cr_list_user_filtered);
  }

  calculDonnesHeuresSaisies(dateDebut: string, dateFin: string): void {
    this.heuresSaisiesService
      .chargerDonnesHeuresSaisies(dateDebut, dateFin)
      .then((activitesSaisies: ActivitesSaisies) => {
        if (activitesSaisies != null) {
          this.minutesDone = activitesSaisies.temps_total;
          this.gaugeData = this.heuresSaisiesService.mapToGaugeData(activitesSaisies);
        }
      })
      .catch((err) => {
        console.error('Erreur calculDonnesHeuresSaisies', err);
        this.gaugeData = null;
      });
  }

  /**
   * Méthode appelée pour que l'on affiche uniquement les CR de la semaine sélectionnée
   */
  filterOtsAndActiviteInternesByDateAndCurrentSegmentVueSemaine() {
    this.cr_list_user_filtered = this.cr_list_user.filter((cr) => {
      // Filtre sur les CR hors activités internes
      if (cr.type === 'cr-response') {
        if (
          cr.ot &&
          cr.date_creation &&
          cr.intervention_date_fin &&
          moment(cr.intervention_date_fin).isBetween(this.startOfWeek, this.endOfWeek)
        ) {
          return true;
        }
      }
      // Filtre sur les activités internes (en cours d'envoi ou déjà envoyés)
      if (cr.type === 'cr-activite-interne') {
        let crActiviteInterne = cr as CrActiviteInterne;
        if (
          crActiviteInterne.cr_activite_interne_date_fin &&
          moment(crActiviteInterne.cr_activite_interne_date_fin).isBetween(this.startOfWeek, this.endOfWeek)
        ) {
          return true;
        }
      }
      return false;
    });
    // Filtre sur les CR en cours d'envoi (offline)
    this.cr_en_cours_denvoi_filtered = this.cr_en_cours_denvoi.filter((cr) => {
      return (
        cr.ot &&
        cr.date_creation &&
        cr.intervention_date_fin &&
        moment(cr.intervention_date_fin).isBetween(this.startOfWeek, this.endOfWeek)
      );
    });
    this.calculDonnesHeuresSaisies(this.startOfWeek, this.endOfWeek);
  }

  /**
   * Méthode appellé lorsque l'utilisateur saisi un caractère
   */
  onSearchInput() {
    this.cr_list_user_filtered = this.cr_list;
    if (this.search == '') return;
    this.cr_list_user_filtered = this.cr_list_user_filtered.filter((v) => {
      if (this.search) {
        let elements_to_search = [];
        if (v.type === 'cr-view' || v.type === 'cr-response') {
          let date = v.date_creation
            ? moment(v.date_creation).format('DD/MM/YYYY à HH:mm')
            : this.translate.instant('CR.DATE_INCONNUE');
          if (date) {
            elements_to_search.push(date);
          }
          if (v.ot && v.ot.libelle_intervention) {
            elements_to_search.push(v.ot.libelle_intervention);
          }
          if (v.ot && v.ot.numero_ot) {
            if (v.ot.numero_ot) elements_to_search.push(v.ot.numero_ot);
          }
          if (v.type === 'cr-view') {
            let vCrView = v as CrView;
            if (vCrView.libelle_intervention) {
              elements_to_search.push(vCrView.libelle_intervention);
            }
          }
          if (v.type === 'cr-response' && v.ot.libelle_intervention) {
            elements_to_search.push(v.ot.libelle_intervention);
          }
        }
        if (v.type === 'cr-activite-interne') {
          const vActiviteInterne = v as CrActiviteInterne;
          if (vActiviteInterne.numero_ot) {
            elements_to_search.push(vActiviteInterne.numero_ot);
          }
          if (vActiviteInterne.cr_type_activite_realisee) {
            elements_to_search.push(vActiviteInterne.cr_type_activite_realisee);
          }
        }
        for (let element of elements_to_search) {
          if (element.toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
            return true;
          }
        }
        return false;
      }
      return false;
    });
  }

  /**
   * Méthode appellé lorsque l'utilisateur clique sur cancel = effacement du champs de Recherche
   */
  onSearchCancel() {
    this.search = '';
    this.cr_list_user_filtered = this.cr_list;
  }

  /**
   * Extraction des dates d'OT de la liste des sites
   *
   * @returns { Array } Retourne un tableau contenant les dates extraites
   */
  extractDates(): string[] {
    let dates: string[] = [];

    // Ajout des dates de chaque CR
    for (let cr of this.cr_list_user) {
      if (cr.type === 'cr-response') {
        if (cr.date_creation) {
          dates.push(moment(cr.date_creation).toISOString());
        }
      }
      // Ajout des dates des CR activité interne
      if (cr.type === 'cr-activite-interne') {
        let crActiviteInterne = cr as CrActiviteInterne;
        if (crActiviteInterne.cr_activite_interne_date_fin) {
          let date_fin: string = moment(crActiviteInterne.cr_activite_interne_date_fin).toISOString();
          if (
            !dates.some((date) => {
              return moment(date_fin).startOf('day').isSame(moment(date).startOf('day'));
            })
          ) {
            dates.push(moment(crActiviteInterne.cr_activite_interne_date_fin).toISOString());
          }
        }
      }
    }
    let today = new Date();
    // Ajout de la date d'aujourd'hui
    dates.push(moment(today).toISOString());
    return dates;
  }

  previous(): void {
    if (this.disableNavigateToPreviousTime) {
      return;
    }
    if (this.segments === segmentsViewEnum.DAY) {
      this.onDateChangedVueJour(minusDays(this.selectedDate, 1));
    } else if (this.segments === segmentsViewEnum.WEEK) {
      this.onDateChangedVueSemaine(minusWeek(this.startOfWeek, 1), minusWeek(this.endOfWeek, 1));
    }
    this.calculerDisableNavigation();
  }

  next(): void {
    if (this.disableNavigateToNextTime) {
      return;
    }
    if (this.segments === segmentsViewEnum.DAY) {
      this.onDateChangedVueJour(plusDays(this.selectedDate, 1));
    } else if (this.segments === segmentsViewEnum.WEEK) {
      this.onDateChangedVueSemaine(plusWeek(this.startOfWeek, 1), plusWeek(this.endOfWeek, 1));
    }
    this.calculerDisableNavigation();
  }

  /**
   * Callback lancé à la validation de la date dans le component calendar pour la vue Jour
   *
   * @param {Date} date date en provenance du calendrier
   */
  onDateChangedVueJour(date: Date) {
    this.selectedDate = date;
    this.defaultDate = date;
    this.filterOtsAndActiviteInternesByDateAndCurrentSegment();
    this.refreshWeekNumberFromDateAndTodayPastille(this.selectedDate);
    this.calculerDisableNavigation();
  }

  /**
   * Callback lancé à la validation de la date dans le component calendar pour la vue Semaine
   *
   * @param startOfWeek
   * @param endOfWeek
   */
  onDateChangedVueSemaine(startOfWeek: string, endOfWeek: string) {
    this.startOfWeek = startOfWeek;
    this.endOfWeek = endOfWeek;
    this.filterOtsAndActiviteInternesByDateAndCurrentSegment();
    this.refreshWeekNumberFromDateAndTodayPastille(this.startOfWeek);
  }

  /**
   * Navigation vers le CR ou le details OT
   */
  async goToCrDetails(cr: PostCrResponse | CrView | PostCrRequest | ChronoInput | UnplannedOt) {
    if (this.isDraftCrDeletionModeActive) {
      return;
    }
    this.logger.log('goToCrDetails', cr);
    if (cr.type === 'chrono-input') {
      let chronoCr = cr as ChronoInput;

      //CAS BROUILLON OT NP
      console.log('Redirect to OT non planifie');
      await this.router.navigate(['/mnt/unplanned-ot'], {
        state: {
          site: { id: chronoCr.id_site },
        },
      });
    } else if (cr.type === 'unplanned-ot') {
      //CAS BROUILLON OT NP
      console.log('Redirect to OT non planifie');
      await this.router.navigate(['/mnt/unplanned-ot'], {
        state: {
          site: { id: cr.id },
        },
      });
    } else if (cr.type === 'cr-view') {
      //CAS BROUILLON CR DEPUIS OT
      console.log('Redirect to OT');
      await this.router.navigate(['/mnt/ots/', cr?.ot.id_ot], {
        queryParams: {
          siteId: cr.ot.site.id_localisation,
        },
      });
    } else if (cr.type === 'post-cr-request') {
      const alert = await this.alertCtrl.create({
        header: $localize`Ce compte-rendu est en cours d'envoi`,
        subHeader: $localize`Son détail sera disponible dès que vous aurez retrouvé du réseau.`,
        buttons: ['Ok'],
      });
      await alert.present();
    } else if (cr.type === 'cr-response') {
      //CAS CR ENVOYE
      console.log('Redirect to Cr Detail');
      let id: string = cr.id_cr;
      await this.router.navigate(['/mnt/crs/', id], {
        state: {
          ot: {},
          cr: cr,
        },
      });
    }
  }

  async goToCrActiviteInterneDetails(crActiviteInterne: CrActiviteInterne) {
    await this.router.navigate(['/mnt/activite-interne'], {
      state: {
        cr: crActiviteInterne,
        editable: false,
      },
    });
  }

  /**
   * Au clic sur une checkbox pour supprimer un CR brouillon
   */
  toogleCheckbox(cr: ChronoInput | CrView | UnplannedOt) {
    if (this.isCrInDeletionList(cr)) {
      this.removeCrFromDeletionList(cr);
    } else {
      this.addCrToDeletionList(cr);
    }
  }

  private addCrToDeletionList(cr: ChronoInput | CrView | UnplannedOt) {
    this.draftCrToDeleteList.push(cr);
  }

  private removeCrFromDeletionList(cr: ChronoInput | CrView | UnplannedOt) {
    this.draftCrToDeleteList.splice(this.getCrIndexInDeletionList(cr), 1);
  }

  private getCrIndexInDeletionList(cr: ChronoInput | CrView | UnplannedOt) {
    return this.draftCrToDeleteList.findIndex((elem) => {
      return elem.id == cr.id;
    });
  }

  isCrInDeletionList(cr: ChronoInput | CrView | UnplannedOt): boolean {
    let found = this.getCrIndexInDeletionList(cr);
    return found !== -1;
  }

  /**
   * Sélectionne tous les brouillons lors de la suppression
   */
  selectAllDraft() {
    // On ne rajoute que les CRs qui ne sont pas déjà dans la liste des CRs à supprimer
    let missingCr = this.cr_list_brouillon.filter((cr) => this.draftCrToDeleteList.indexOf(cr) < 0);
    this.draftCrToDeleteList.push(...missingCr);
  }

  /**
   * Au clic sur le bouton icone trash / supprimer
   */
  toggleDelete() {
    if (this.isDraftCrDeletionModeActive == false) {
      this.isDraftCrDeletionModeActive = true;
    } else {
      this.presentAlertConfirmDelete();
    }
  }

  /**
   * Permet de quitter la suppression des CR brouillons
   */
  toggleCancel() {
    this.isDraftCrDeletionModeActive = false;
    this.draftCrToDeleteList = [];
  }

  /**
   * Permet de griser le bouton de suppression des CR brouillons
   */
  isButtonDeleteDisabled(): boolean {
    return (
      this.cr_list_brouillon.length === 0 || (this.isDraftCrDeletionModeActive && this.draftCrToDeleteList.length === 0)
    );
  }

  /**
   * Affichage de la modale de confirmation lors de la suppression des CR brouillons
   */
  presentAlertConfirmDelete() {
    if (this.draftCrToDeleteList.length === this.cr_list_brouillon.length) {
      this.alertConfirm('CR.ALERT_DELETE_ALL_DRAFT', true);
    } else {
      this.alertConfirm('CR.ALERT_DELETE_TITLE_LIST', false);
    }
  }

  private async alertConfirm(trad: string, displayToast: boolean) {
    let alertButtons: AlertButton[] = [
      {
        text: this.translate.instant('GLOBAL.YES'),
        handler: async () => {
          await this.deleteSelectedCR(displayToast);
        },
      },
      {
        text: this.translate.instant('GLOBAL.NO'),
        handler: () => {
          this.draftCrToDeleteList = [];
          this.isDraftCrDeletionModeActive = false;
        },
      },
    ];

    let alert: HTMLIonAlertElement = await this.alertCtrl.create({
      cssClass: 'alertButtons alertMessageWarningP1',
      header: this.translate.instant(trad),
      message: this.translate.instant('CR.ALERT_DELETE_SEVERAL_WARNING_P1'),
      backdropDismiss: false,
      buttons: alertButtons,
    });

    await alert.present();
  }

  /**
   * Suppression des CR brouillons selectionnés
   */
  async deleteSelectedCR(displayToast: boolean) {
    for (let cr_to_delete of this.draftCrToDeleteList) {
      console.log('deleteSelectedCR', cr_to_delete);
      await this.deleteBrouillon(cr_to_delete);
      let index = this.cr_list_brouillon.findIndex((elem) => {
        return elem.id == cr_to_delete.id;
      });
      this.cr_list_brouillon.splice(index, 1);
    }
    this.draftCrToDeleteList = [];
    this.isDraftCrDeletionModeActive = false;

    if (displayToast) {
      await this.displayToastAfterDeletingAllDraft();
    }
  }

  async displayToastAfterDeletingAllDraft() {
    const toast: HTMLIonToastElement = await this.toastController.create({
      message: this.translate.instant('CR.TOAST_MESSAGE_ALL_DRAFT_DELETED'),
      duration: 3000,
    });
    await toast.present();
  }

  /**
   * Supprimer un CR dans le storage
   */
  async deleteBrouillon(cr: ChronoInput | CrView | UnplannedOt) {
    if (cr.type === 'chrono-input' || cr.type === 'unplanned-ot') {
      console.log('deleteBrouillon OT NP');
      //CAS BROUILLON OT NP
      await this.storageProvider.removeDraft(cr, 'DraftOtUnplanned');
    } else if (cr.type === 'cr-view') {
      console.log('deleteBrouillon OT');
      //CAS BROUILLON OT
      await this.storageProvider.removeDraft(cr, 'DraftOt');
      await this.draftCrService.removeCrDraft(cr.id);
    }
  }

  /**
   * Méthode appellé pour cacher le clavier
   */
  async closeKeyboard() {
    await Keyboard.hide();
  }

  /**
   * Récupere les activités internes
   */
  async refreshCrsActiviteInterne() {
    this.crsActiviteInterne = await this.serviceActiviteInterne.getCr();
  }

  /**
   * Récupère les données du storage des données 'offline' en attente d'être envoyées au backend
   * et les filtres pour n'avoir que les CRs en cours d'envoi.
   */
  private async getCrsEnCoursDenvoi(): Promise<PostCrRequest[]> {
    const requests = await this.offlineSyncProvider.getRequests();
    return requests
      .filter((req) => req.data && req.data.type === TypeDataRequest.CRS_WITH_RELEVES_AND_PRIMES && req.data.cr)
      .map((req) => req.data.cr);
  }

  /**
   * Méthode appelée lorsqu'on bascule d'un vue (jour ou semaine) à une autre
   */
  segmentAction() {
    this.filterOtsAndActiviteInternesByDateAndCurrentSegment();
    this.calculerDisableNavigation();
  }

  /**
   * Rafraîchit le numéro de la semaine à partir de la date passée en paramètre
   * @param date
   */
  refreshWeekNumberFromDateAndTodayPastille(date: Date | string) {
    this.refreshWeekNumber(date);
    this.todayInSelectedDates.set(this.refreshTodayPastille());
  }
  refreshWeekNumber(date: Date | string) {
    this.week = moment(date).week();
  }
  refreshTodayPastille() {
    const today = new Date();
    switch (this.segments) {
      case segmentsViewEnum.DAY:
        return sameDay(this.selectedDate, today);
      case segmentsViewEnum.WEEK:
        return moment(today).isBetween(moment(this.startOfWeek), moment(this.endOfWeek));
    }
  }

  get minutesDoneToDisplay(): number {
    return this.isConnected ? this.minutesDone : 75;
  }

  get maxMinutesToDisplay(): number {
    if (this.segments === segmentsViewEnum.DAY) {
      return this.isConnected ? this.maxMinutesInDay : 100;
    } else {
      return this.isConnected ? this.maxMinutesInWeek : 100;
    }
  }

  goToCurrentWeek() {
    this.onDateChangedVueSemaine(moment().startOf('isoWeek').toISOString(), moment().endOf('isoWeek').toISOString());
    this.calculerDisableNavigation();
  }

  goToCurrentDay() {
    this.onDateChangedVueJour(new Date());
    this.calculerDisableNavigation();
  }

  async openCalendarModal(): Promise<void> {
    let modal: HTMLIonModalElement = await this.modalController.create({
      component: CalendarModal,
      componentProps: {
        title: this.datePipe.transform(this.defaultDate, 'dd MMMM'),
        selectedDate: this.defaultDate,
        minDate: moment().subtract(5, 'weeks').toDate(),
        maxDate: new Date(),
        highlightedDates: this.extractDates(),
      },
    });
    await modal.present();

    modal.onDidDismiss().then((event) => {
      if (event.data) {
        this.onDateChangedVueJour(event.data);
      }
    });
  }

  onPastilleClicked() {
    if (!this.todayInSelectedDates()) {
      if (this.segments === 'jour') {
        this.goToCurrentDay();
      } else {
        this.goToCurrentWeek();
      }
    }
  }

  protected readonly CrActiviteInterne = CrActiviteInterne;
}
